import React from 'react';
import PropTypes from 'prop-types';

import { randomIdGenerator } from '../services/utils';
import { prepareImgixParams, placeholder43Url } from '../services/APIClient';

// Show at least 3 images, actual or placeholder.
const MIN_IMAGE_COUNT = 3;

const BrandFeaturedGallery = ({ images }) => {
  // Make an array of placeholders if there are fewer than three images
  const placeholders = new Array(MIN_IMAGE_COUNT - images.length)
    .fill({ url: placeholder43Url })
    .map(item => Object.assign({}, item, { id: randomIdGenerator() }));

  return (
    <div className="row">
      {/* Gallery Images */}
      {images.map(({ mediaItem: { id, url } }) => {
        const croppedUrl = prepareImgixParams(url, { w: 400, h: 240, auto: 'format,compress' });
        return (
          <div key={id} className="medium-4 small-12 mb-l columns">
            <div
              style={{
                backgroundImage: `url(${croppedUrl})`,
                backgroundPosition: '50% 50%',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                position: 'relative',
                width: 'inherit',
                minHeight: '15rem',
                borderRadius: '0.25rem',
              }}
            />
          </div>
        );
      })}

      {/* Placeholders */}
      {placeholders.map(({ url, id }) => (
        <div
          key={id}
          className="medium-4 small-12 mb-l columns"
        >
          <div
            style={{
              backgroundImage: `url(${url})`,
              backgroundPosition: '50% 50%',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              position: 'relative',
              width: 'inherit',
              minHeight: '15rem',
              borderRadius: '0.25rem',
            }}
          />
        </div>
      ))}
    </div>
  );
};

BrandFeaturedGallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.oneOf(['LOGO', 'HERO', 'GALLERY']),
    mediaItem: PropTypes.shape({
      id: PropTypes.string,
      url: PropTypes.string,
      originalName: PropTypes.string,
    }),
  })),
};

BrandFeaturedGallery.defaultProps = {
  images: [{
    type: 'GALLERY',
    mediaItem: {
      id: '',
      url: 'http://via.placeholder.com/400x200',
      originalName: '',
    },
  }],
};

export default BrandFeaturedGallery;
